import {ChangeDetectorRef, Component, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {AnalysisMethodsService} from 'src/app/services/config/analysis-methods.service';
import {UserService} from 'src/app/services/user.service';
import {CriteriaService} from 'src/app/services/config/criteria.service';
import {UnitsService} from 'src/app/services/config/units.service';
import {WorkingSectorsService} from 'src/app/services/config/workingSectors.service';
import {ToastService} from 'src/app/services/general/toast.service';
import {FrameworkService} from 'src/app/services/framework.service';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {HeaderTitleService} from 'src/app/services/general/header-title.service';
import {ProcessRolesService} from 'src/app/services/config/process-roles.service';
import {TranslateService} from '@ngx-translate/core';
import {MatDialog} from '@angular/material/dialog';
import {ModalUploadFrameworkComponent} from 'src/app/modals/modal-upload-framework/modal-upload-framework.component';

export interface SectionRow {
  section: string;
  negRed: string;
  negYellow: string;
  negGreen: string;
  flagRule: 'Attivo' | 'Disattivo';
  manualOverride: 'Abilitato' | 'Non abilitato';
  notes: string;
}

const ELEMENT_DATA: SectionRow[] = [
  {
    section: 'Cyber Security & GDPR Compliance Index',
    negRed: '≥ 40',
    negYellow: '20-39',
    negGreen: '< 20',
    flagRule: 'Attivo',
    manualOverride: 'Abilitato',
    notes: 'Valuta anche endpoint surrogati'
  },
  {
    section: 'Information Security Management',
    negRed: '≥ 50',
    negYellow: '30-49',
    negGreen: '< 30',
    flagRule: 'Attivo',
    manualOverride: 'Abilitato',
    notes: '1 flag “showstopper” blocca tutto'
  },
  {
    section: 'Data Protection & Privacy',
    negRed: '≥ 33',
    negYellow: '15-32',
    negGreen: '< 15',
    flagRule: 'Disattivo',
    manualOverride: 'Abilitato',
    notes: 'Criteri meno stringenti'
  },
  {
    section: 'Business Continuity & Disaster Recovery',
    negRed: '≥ 50',
    negYellow: '30-49',
    negGreen: '< 30',
    flagRule: 'Attivo',
    manualOverride: 'Non abilitato',
    notes: 'Nessuna override ammessa'
  },
  {
    section: 'Access Control & Identity Management',
    negRed: '≥ 60',
    negYellow: '40-59',
    negGreen: '< 40',
    flagRule: 'Attivo',
    manualOverride: 'Abilitato',
    notes: 'Personalizzabile in demo'
  },
  {
    section: 'Incident Response & Security Monitoring',
    negRed: '≥ 45',
    negYellow: '25-44',
    negGreen: '< 25',
    flagRule: 'Attivo',
    manualOverride: 'Abilitato',
    notes: 'Valuta tempi di risposta agli incidenti'
  },
  {
    section: 'Third Party & Supply Chain Security',
    negRed: '≥ 55',
    negYellow: '35-54',
    negGreen: '< 35',
    flagRule: 'Attivo',
    manualOverride: 'Non abilitato',
    notes: 'Attenzione ai fornitori critici'
  }
];


@Component({
  selector: 'app-framework',
  templateUrl: './framework.component.html',
  styleUrls: ['./framework.component.scss']
})
export class FrameworkComponent implements OnInit {

  private _activeRouteSubscription: Subscription;

  loading = false;

  id: any;

  sections = [
    {
      key: 'Clinical',
      value: 'Clinical'
    },
    {
      key: 'Marketing',
      value: 'Marketing'
    },
    {
      key: 'Legal',
      value: 'Legal'
    },
    {
      key: 'Industrial',
      value: 'Industrial'
    },
    {
      key: 'Manufacturing',
      value: 'Manufacturing'
    },
    {
      key: 'Regolatorio',
      value: 'Regolatorio'
    },
    {
      key: 'Market Access',
      value: 'Market Access'
    }
  ];

  displayedColumns: string[] = ['section', 'negRed', 'negYellow', 'negGreen', 'flagRule', 'manualOverride', 'notes'];
  dataSource = ELEMENT_DATA;


  //  modello del framework
  model: any = {
    title: null,
    organization_id: null,
    analysis_type: null,
    public: false,
    hidden: false,
    sectors: [],
    purpose_description: '',
    primary_target: {type: 'primary', title: '', evaluation_criteria: null},
    secondary_targets: [],
    criteria: [],
    constraints: [],
    options_role: false,
    options_role_required: false,
    roles: [],
    criticalFlag: false
  };

  weights_is_setted = false;
  weights_mandatories = null;

  process_roles: any = [];
  analysisMethods: any = [];
  userorganization: any = [];
  professionalRoles: any = [];
  currentOrganization: any = {};

  constructor(private toast: ToastService, private unitsService: UnitsService, private criteriaService: CriteriaService,
              private workingSectorService: WorkingSectorsService, private analysisMethodsService: AnalysisMethodsService,
              public userService: UserService, private frameworkService: FrameworkService,
              private activeRoute: ActivatedRoute, private router: Router, private headerTitleService: HeaderTitleService,
              private processRolesService: ProcessRolesService, private translateService: TranslateService,
              public dialog: MatDialog,
              private analysisService: AnalysisMethodsService,
              private cdr: ChangeDetectorRef) {
  }

  settedWeights: any = null;


  ngOnInit(): void {

    //  controllo se sono in modifica o in creazione
    this._activeRouteSubscription = this.activeRoute.params.subscribe(routeParams => {
      this.id = routeParams.id_framework;
      if (this.id) {
        this.frameworkService.get(this.id, (result) => {
          this.model = result;
          this.init();
        }, () => {
          this.router.navigate(['/framework']);
          this.loading = false;
        });
      } else {
        this.init();
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribeAll();
  }

  unsubscribeAll() {
    if (this._activeRouteSubscription) {
      this._activeRouteSubscription.unsubscribe();
    }
  }

  init() {

    //  inizializzo i metodi disponibili
    this.analysisMethods = this.analysisMethodsService.getAllAnalysisMethods().map(v => ({...v, enabled: false}));

    //  inizializzo i ruoli nei processi decisionali
    this.process_roles = this.processRolesService.getAllProcessRoles();

    //  inizializzo i dati dell'utente
    this.userorganization = this.userService.getAllOrganizations();

    //  recupero i dati dei ruoli professionali dell'organizzazione corrente
    this.professionalRoles = this.userService.getAllProfessionalRolesForCurrentOrganization();

    //  all'avvio inserisco un settore vuoto
    if (this.model.sectors.length == 0) {
      this.addSector();
    }

    //  all'avvio inserisco un criterio vuoto
    if (this.model.criteria.length == 0) {
      this.addCriteria();
    }

    //  all'avvio inserisco un ruolo vuoto
    // if (this.model.roles.length == 0)
    //   this.addRole();

    //  pulisco i ceriteri se sono arrivati senza valori di informazioni aggiuntive
    this.model.criteria.forEach(criterio => {
      if (!criterio.additional) {
        criterio.additional = {};
      }
    });

    //  setto il metodo di analisi se presente
    if (this.model.analysis_type) {
      const methodIndex = this.analysisMethods.findIndex(x => x.type == this.model.analysis_type);
      if (methodIndex >= 0) {
        this.analysisMethods[methodIndex].enabled = true;
      }
    }

    //  setto le opzioni per i ruoli del team
    this.model.options_role = this.model.options_role != 0;
    this.model.options_role_required = this.model.options_role_required != 0;

    //  costruisco l'array dei vincoli
    this.model.constraints.forEach(constraint => {
      const criteria1 = this.model.criteria.find(x => x.id == constraint.framework_criteria_1_id);
      const criteria2 = this.model.criteria.find(x => x.id == constraint.framework_criteria_2_id);
      constraint.criteria_1_order = criteria1?.order;
      constraint.criteria_2_order = criteria2?.order;
    });

    //  setto l'organizzazione se presente
    if (this.model.organization_id) {
      this.selectOrganizationOnChange();
    }

    //  setto il titolo della pagina
    if (this.model.id) {
      this.headerTitleService.setSubtitle(this.model.title);
    }

    this.currentOrganization = this.userService.getCurrentOrganization();

    // this.model = {"id":70,"created_at":"2024-10-29T16:02:54.000000Z","updated_at":"2024-10-29T16:02:54.000000Z","deleted_at":null,"title":"Modello Decisionale per la Valutazione del Rischio di ricaduta in Pazienti con NMOSD","createdby_user_id":2,"organization_id":13,"analysis_type":1,"purpose_description":"Questo template decisionale \u00e8 progettato specificamente per la valutazione del rischio in pazienti affetti da NMOSD (Neuromyelitis Optica Spectrum Disorder). Ogni elemento della checklist (check) \u00e8 associato a diverse opzioni di risposta, ciascuna assegnata con un peso percentuale specifico. Questo peso incide direttamente sul calcolo dell'indice di rischio complessivo del paziente. La somma ponderata dei punteggi ottenuti in ciascun check fornisce una misura quantitativa dell'indice di rischio, permettendo una valutazione accurata e personalizzata dello stato clinico del paziente. Il modello si basa su un approccio olistico, considerando vari aspetti della patologia, dalla storia clinica ai sintomi attuali, fino alla risposta al trattamento. Questo consente ai clinici di ottenere una visione completa e dettagliata, essenziale per l'ottimizzazione della gestione dei pazienti con NMOSD. Il template \u00e8 uno strumento essenziale per la stratificazione del rischio, facilitando decisioni cliniche informate e tempestive. L'uso di questo template pu\u00f2 essere particolarmente utile per neurologi e altri professionisti della salute impegnati nella gestione del NMOSD, offrendo un metodo strutturato e basato su dati per la valutazione del rischio di ricadute e per la pianificazione del trattamento.","options_role":0,"options_role_required":0,"public":false,"hidden":0,"weights_is_mandatories":1,"sectors":[{"id":72,"created_at":"2024-10-29T16:02:54.000000Z","updated_at":"2024-10-29T16:02:54.000000Z","deleted_at":null,"framework_id":70,"sector_key":"MEDICINE","subsector_key":"NEUROLOGY"}],"primary_target":{"id":138,"created_at":"2024-10-29T16:02:54.000000Z","updated_at":"2024-10-29T16:02:54.000000Z","deleted_at":null,"framework_id":70,"type":"primary","title":"Rischio di Ricaduta","evaluation_criteria":"LOWESTISTHEBEST"},"secondary_targets":[],"criteria":[{"id":1439,"created_at":"2024-10-29T16:02:54.000000Z","updated_at":"2024-10-29T16:02:54.000000Z","deleted_at":null,"framework_id":70,"title":"Nuovi Sintomi","typology":"MULTIPLECHOICE","measure_unit":null,"evaluation":null,"order":0,"options":[{"id":6148,"created_at":"2024-10-29T16:02:54.000000Z","updated_at":"2024-10-29T16:02:54.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1439,"title":"Si","weight":100},{"id":6149,"created_at":"2024-10-29T16:02:54.000000Z","updated_at":"2024-10-29T16:02:54.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1439,"title":"No","weight":0}],"additional":{"id":1160,"created_at":"2024-10-29T16:02:54.000000Z","updated_at":"2024-10-29T16:02:54.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1439,"item_id":null,"section":"VALUTAZIONE SINTOMI","sub_section":"VALUTAZIONE SINTOMI","preliminary_check":null,"check_n":null,"requirement":null,"reference":null}},{"id":1440,"created_at":"2024-10-29T16:02:55.000000Z","updated_at":"2024-10-29T16:02:55.000000Z","deleted_at":null,"framework_id":70,"title":"Sintomi Visivi","typology":"MULTIPLECHOICE","measure_unit":null,"evaluation":null,"order":1,"options":[{"id":6150,"created_at":"2024-10-29T16:02:55.000000Z","updated_at":"2024-10-29T16:02:55.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1440,"title":"Nessuno","weight":0},{"id":6151,"created_at":"2024-10-29T16:02:55.000000Z","updated_at":"2024-10-29T16:02:55.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1440,"title":"Lieve","weight":25},{"id":6152,"created_at":"2024-10-29T16:02:55.000000Z","updated_at":"2024-10-29T16:02:55.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1440,"title":"Moderato","weight":50},{"id":6153,"created_at":"2024-10-29T16:02:55.000000Z","updated_at":"2024-10-29T16:02:55.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1440,"title":"Grave","weight":75},{"id":6154,"created_at":"2024-10-29T16:02:55.000000Z","updated_at":"2024-10-29T16:02:55.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1440,"title":"Molto Grave","weight":100}],"additional":{"id":1161,"created_at":"2024-10-29T16:02:55.000000Z","updated_at":"2024-10-29T16:02:55.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1440,"item_id":null,"section":"VALUTAZIONE SINTOMI","sub_section":"VALUTAZIONE SINTOMI","preliminary_check":null,"check_n":null,"requirement":null,"reference":null}},{"id":1441,"created_at":"2024-10-29T16:02:55.000000Z","updated_at":"2024-10-29T16:02:55.000000Z","deleted_at":null,"framework_id":70,"title":"Sintomi Motori","typology":"MULTIPLECHOICE","measure_unit":null,"evaluation":null,"order":2,"options":[{"id":6155,"created_at":"2024-10-29T16:02:56.000000Z","updated_at":"2024-10-29T16:02:56.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1441,"title":"Nessuno","weight":0},{"id":6156,"created_at":"2024-10-29T16:02:56.000000Z","updated_at":"2024-10-29T16:02:56.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1441,"title":"Lieve","weight":25},{"id":6157,"created_at":"2024-10-29T16:02:56.000000Z","updated_at":"2024-10-29T16:02:56.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1441,"title":"Moderato","weight":50},{"id":6158,"created_at":"2024-10-29T16:02:56.000000Z","updated_at":"2024-10-29T16:02:56.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1441,"title":"Grave","weight":75},{"id":6159,"created_at":"2024-10-29T16:02:56.000000Z","updated_at":"2024-10-29T16:02:56.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1441,"title":"Molto Grave","weight":100}],"additional":{"id":1162,"created_at":"2024-10-29T16:02:56.000000Z","updated_at":"2024-10-29T16:02:56.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1441,"item_id":null,"section":"VALUTAZIONE SINTOMI","sub_section":"VALUTAZIONE SINTOMI","preliminary_check":null,"check_n":null,"requirement":null,"reference":null}},{"id":1442,"created_at":"2024-10-29T16:02:56.000000Z","updated_at":"2024-10-29T16:02:56.000000Z","deleted_at":null,"framework_id":70,"title":"Sintomi Sensitivi","typology":"MULTIPLECHOICE","measure_unit":null,"evaluation":null,"order":3,"options":[{"id":6160,"created_at":"2024-10-29T16:02:56.000000Z","updated_at":"2024-10-29T16:02:56.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1442,"title":"Nessuno","weight":0},{"id":6161,"created_at":"2024-10-29T16:02:56.000000Z","updated_at":"2024-10-29T16:02:56.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1442,"title":"Lieve","weight":25},{"id":6162,"created_at":"2024-10-29T16:02:57.000000Z","updated_at":"2024-10-29T16:02:57.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1442,"title":"Moderato","weight":50},{"id":6163,"created_at":"2024-10-29T16:02:57.000000Z","updated_at":"2024-10-29T16:02:57.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1442,"title":"Grave","weight":75},{"id":6164,"created_at":"2024-10-29T16:02:57.000000Z","updated_at":"2024-10-29T16:02:57.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1442,"title":"Molto Grave","weight":100}],"additional":{"id":1163,"created_at":"2024-10-29T16:02:57.000000Z","updated_at":"2024-10-29T16:02:57.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1442,"item_id":null,"section":"VALUTAZIONE SINTOMI","sub_section":"VALUTAZIONE SINTOMI","preliminary_check":null,"check_n":null,"requirement":null,"reference":null}},{"id":1443,"created_at":"2024-10-29T16:02:57.000000Z","updated_at":"2024-10-29T16:02:57.000000Z","deleted_at":null,"framework_id":70,"title":"Sintomi Sfinterici","typology":"MULTIPLECHOICE","measure_unit":null,"evaluation":null,"order":4,"options":[{"id":6165,"created_at":"2024-10-29T16:02:57.000000Z","updated_at":"2024-10-29T16:02:57.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1443,"title":"Nessuno","weight":0},{"id":6166,"created_at":"2024-10-29T16:02:57.000000Z","updated_at":"2024-10-29T16:02:57.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1443,"title":"Lieve","weight":25},{"id":6167,"created_at":"2024-10-29T16:02:57.000000Z","updated_at":"2024-10-29T16:02:57.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1443,"title":"Moderato","weight":50},{"id":6168,"created_at":"2024-10-29T16:02:58.000000Z","updated_at":"2024-10-29T16:02:58.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1443,"title":"Grave","weight":75},{"id":6169,"created_at":"2024-10-29T16:02:58.000000Z","updated_at":"2024-10-29T16:02:58.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1443,"title":"Molto Grave","weight":100}],"additional":{"id":1164,"created_at":"2024-10-29T16:02:58.000000Z","updated_at":"2024-10-29T16:02:58.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1443,"item_id":null,"section":"VALUTAZIONE SINTOMI","sub_section":"VALUTAZIONE SINTOMI","preliminary_check":null,"check_n":null,"requirement":null,"reference":null}},{"id":1444,"created_at":"2024-10-29T16:02:58.000000Z","updated_at":"2024-10-29T16:02:58.000000Z","deleted_at":null,"framework_id":70,"title":"Sintomi Bulbari","typology":"MULTIPLECHOICE","measure_unit":null,"evaluation":null,"order":5,"options":[{"id":6170,"created_at":"2024-10-29T16:02:58.000000Z","updated_at":"2024-10-29T16:02:58.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1444,"title":"Nessuno","weight":0},{"id":6171,"created_at":"2024-10-29T16:02:58.000000Z","updated_at":"2024-10-29T16:02:58.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1444,"title":"Lieve","weight":25},{"id":6172,"created_at":"2024-10-29T16:02:58.000000Z","updated_at":"2024-10-29T16:02:58.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1444,"title":"Moderato","weight":50},{"id":6173,"created_at":"2024-10-29T16:02:58.000000Z","updated_at":"2024-10-29T16:02:58.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1444,"title":"Grave","weight":75},{"id":6174,"created_at":"2024-10-29T16:02:58.000000Z","updated_at":"2024-10-29T16:02:58.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1444,"title":"Molto Grave","weight":100}],"additional":{"id":1165,"created_at":"2024-10-29T16:02:59.000000Z","updated_at":"2024-10-29T16:02:59.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1444,"item_id":null,"section":"VALUTAZIONE SINTOMI","sub_section":"VALUTAZIONE SINTOMI","preliminary_check":null,"check_n":null,"requirement":null,"reference":null}},{"id":1445,"created_at":"2024-10-29T16:02:59.000000Z","updated_at":"2024-10-29T16:02:59.000000Z","deleted_at":null,"framework_id":70,"title":"Dolore Neuropatico","typology":"MULTIPLECHOICE","measure_unit":null,"evaluation":null,"order":6,"options":[{"id":6175,"created_at":"2024-10-29T16:02:59.000000Z","updated_at":"2024-10-29T16:02:59.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1445,"title":"Nessuno","weight":0},{"id":6176,"created_at":"2024-10-29T16:02:59.000000Z","updated_at":"2024-10-29T16:02:59.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1445,"title":"Lieve","weight":25},{"id":6177,"created_at":"2024-10-29T16:02:59.000000Z","updated_at":"2024-10-29T16:02:59.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1445,"title":"Moderato","weight":50},{"id":6178,"created_at":"2024-10-29T16:02:59.000000Z","updated_at":"2024-10-29T16:02:59.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1445,"title":"Grave","weight":75},{"id":6179,"created_at":"2024-10-29T16:02:59.000000Z","updated_at":"2024-10-29T16:02:59.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1445,"title":"Molto Grave","weight":100}],"additional":{"id":1166,"created_at":"2024-10-29T16:02:59.000000Z","updated_at":"2024-10-29T16:02:59.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1445,"item_id":null,"section":"VALUTAZIONE SINTOMI","sub_section":"VALUTAZIONE SINTOMI","preliminary_check":null,"check_n":null,"requirement":null,"reference":null}},{"id":1446,"created_at":"2024-10-29T16:03:00.000000Z","updated_at":"2024-10-29T16:03:00.000000Z","deleted_at":null,"framework_id":70,"title":"Trattamenti in Corso (questo check non influir\u00e0 nel calcolo dell\u2019indice di rischio)Recupero dai Sintomi","typology":"MULTIPLECHOICE","measure_unit":null,"evaluation":null,"order":7,"options":[{"id":6180,"created_at":"2024-10-29T16:03:00.000000Z","updated_at":"2024-10-29T16:03:00.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1446,"title":"Rituximab","weight":0},{"id":6181,"created_at":"2024-10-29T16:03:00.000000Z","updated_at":"2024-10-29T16:03:00.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1446,"title":"Inebilizumab","weight":0},{"id":6182,"created_at":"2024-10-29T16:03:00.000000Z","updated_at":"2024-10-29T16:03:00.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1446,"title":"Satralizumab","weight":0},{"id":6183,"created_at":"2024-10-29T16:03:00.000000Z","updated_at":"2024-10-29T16:03:00.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1446,"title":"Altri (specificare)","weight":0}],"additional":{"id":1167,"created_at":"2024-10-29T16:03:00.000000Z","updated_at":"2024-10-29T16:03:00.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1446,"item_id":null,"section":"STORIA CLINICA DEL PAZIENTE","sub_section":"STORIA CLINICA DEL PAZIENTE","preliminary_check":null,"check_n":null,"requirement":null,"reference":null}},{"id":1447,"created_at":"2024-10-29T16:03:01.000000Z","updated_at":"2024-10-29T16:03:01.000000Z","deleted_at":null,"framework_id":70,"title":"Numero di Ricadute negli Ultimi 12 Mesi","typology":"MULTIPLECHOICE","measure_unit":null,"evaluation":null,"order":8,"options":[{"id":6184,"created_at":"2024-10-29T16:03:01.000000Z","updated_at":"2024-10-29T16:03:01.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1447,"title":"Nessuno","weight":0},{"id":6185,"created_at":"2024-10-29T16:03:01.000000Z","updated_at":"2024-10-29T16:03:01.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1447,"title":"1 episodio","weight":33},{"id":6186,"created_at":"2024-10-29T16:03:01.000000Z","updated_at":"2024-10-29T16:03:01.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1447,"title":"2 episodi","weight":67},{"id":6187,"created_at":"2024-10-29T16:03:01.000000Z","updated_at":"2024-10-29T16:03:01.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1447,"title":"> 2 episodi","weight":100}],"additional":{"id":1168,"created_at":"2024-10-29T16:03:01.000000Z","updated_at":"2024-10-29T16:03:01.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1447,"item_id":null,"section":"STORIA CLINICA DEL PAZIENTE","sub_section":"STORIA CLINICA DEL PAZIENTE","preliminary_check":null,"check_n":null,"requirement":null,"reference":null}},{"id":1448,"created_at":"2024-10-29T16:03:01.000000Z","updated_at":"2024-10-29T16:03:01.000000Z","deleted_at":null,"framework_id":70,"title":"Recupero dai Sintomi","typology":"MULTIPLECHOICE","measure_unit":null,"evaluation":null,"order":9,"options":[{"id":6188,"created_at":"2024-10-29T16:03:01.000000Z","updated_at":"2024-10-29T16:03:01.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1448,"title":"Completo","weight":0},{"id":6189,"created_at":"2024-10-29T16:03:02.000000Z","updated_at":"2024-10-29T16:03:02.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1448,"title":"Parziale","weight":50},{"id":6190,"created_at":"2024-10-29T16:03:02.000000Z","updated_at":"2024-10-29T16:03:02.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1448,"title":"Nessun recupero","weight":100}],"additional":{"id":1169,"created_at":"2024-10-29T16:03:02.000000Z","updated_at":"2024-10-29T16:03:02.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1448,"item_id":null,"section":"STORIA CLINICA DEL PAZIENTE","sub_section":"STORIA CLINICA DEL PAZIENTE","preliminary_check":null,"check_n":null,"requirement":null,"reference":null}},{"id":1449,"created_at":"2024-10-29T16:03:02.000000Z","updated_at":"2024-10-29T16:03:02.000000Z","deleted_at":null,"framework_id":70,"title":"Episodi Infettivi Recenti","typology":"MULTIPLECHOICE","measure_unit":null,"evaluation":null,"order":10,"options":[{"id":6191,"created_at":"2024-10-29T16:03:02.000000Z","updated_at":"2024-10-29T16:03:02.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1449,"title":"Nessuno","weight":0},{"id":6192,"created_at":"2024-10-29T16:03:02.000000Z","updated_at":"2024-10-29T16:03:02.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1449,"title":"1 episodio","weight":33},{"id":6193,"created_at":"2024-10-29T16:03:02.000000Z","updated_at":"2024-10-29T16:03:02.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1449,"title":"2 episodi","weight":67},{"id":6194,"created_at":"2024-10-29T16:03:02.000000Z","updated_at":"2024-10-29T16:03:02.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1449,"title":"> 2 episodi","weight":100}],"additional":{"id":1170,"created_at":"2024-10-29T16:03:02.000000Z","updated_at":"2024-10-29T16:03:02.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1449,"item_id":null,"section":"STORIA CLINICA DEL PAZIENTE","sub_section":"STORIA CLINICA DEL PAZIENTE","preliminary_check":null,"check_n":null,"requirement":null,"reference":null}},{"id":1450,"created_at":"2024-10-29T16:03:03.000000Z","updated_at":"2024-10-29T16:03:03.000000Z","deleted_at":null,"framework_id":70,"title":"Aderenza al Trattamento","typology":"MULTIPLECHOICE","measure_unit":null,"evaluation":null,"order":11,"options":[{"id":6195,"created_at":"2024-10-29T16:03:03.000000Z","updated_at":"2024-10-29T16:03:03.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1450,"title":"Completa","weight":0},{"id":6196,"created_at":"2024-10-29T16:03:03.000000Z","updated_at":"2024-10-29T16:03:03.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1450,"title":"Parziale","weight":50},{"id":6197,"created_at":"2024-10-29T16:03:03.000000Z","updated_at":"2024-10-29T16:03:03.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1450,"title":"Irregolare","weight":100}],"additional":{"id":1171,"created_at":"2024-10-29T16:03:03.000000Z","updated_at":"2024-10-29T16:03:03.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1450,"item_id":null,"section":"STORIA CLINICA DEL PAZIENTE","sub_section":"STORIA CLINICA DEL PAZIENTE","preliminary_check":null,"check_n":null,"requirement":null,"reference":null}},{"id":1451,"created_at":"2024-10-29T16:03:03.000000Z","updated_at":"2024-10-29T16:03:03.000000Z","deleted_at":null,"framework_id":70,"title":"Comorbidit\u00e0 Autoimmuni","typology":"MULTIPLECHOICE","measure_unit":null,"evaluation":null,"order":12,"options":[{"id":6198,"created_at":"2024-10-29T16:03:03.000000Z","updated_at":"2024-10-29T16:03:03.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1451,"title":"Nessuna","weight":0},{"id":6199,"created_at":"2024-10-29T16:03:03.000000Z","updated_at":"2024-10-29T16:03:03.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1451,"title":"Presente","weight":100}],"additional":{"id":1172,"created_at":"2024-10-29T16:03:04.000000Z","updated_at":"2024-10-29T16:03:04.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1451,"item_id":null,"section":"STORIA CLINICA DEL PAZIENTE","sub_section":"STORIA CLINICA DEL PAZIENTE","preliminary_check":null,"check_n":null,"requirement":null,"reference":null}},{"id":1452,"created_at":"2024-10-29T16:03:04.000000Z","updated_at":"2024-10-29T16:03:04.000000Z","deleted_at":null,"framework_id":70,"title":"Risposta alla Terapia Steroidea","typology":"MULTIPLECHOICE","measure_unit":null,"evaluation":null,"order":13,"options":[{"id":6200,"created_at":"2024-10-29T16:03:04.000000Z","updated_at":"2024-10-29T16:03:04.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1452,"title":"Buona","weight":0},{"id":6201,"created_at":"2024-10-29T16:03:04.000000Z","updated_at":"2024-10-29T16:03:04.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1452,"title":"Moderata","weight":33},{"id":6202,"created_at":"2024-10-29T16:03:04.000000Z","updated_at":"2024-10-29T16:03:04.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1452,"title":"Scarsa","weight":67},{"id":6203,"created_at":"2024-10-29T16:03:04.000000Z","updated_at":"2024-10-29T16:03:04.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1452,"title":"Nessuna","weight":100}],"additional":{"id":1173,"created_at":"2024-10-29T16:03:04.000000Z","updated_at":"2024-10-29T16:03:04.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1452,"item_id":null,"section":"FATTORI DI RISCHIO E INDICATORI DI PROGNOSI","sub_section":"FATTORI DI RISCHIO E INDICATORI DI PROGNOSI","preliminary_check":null,"check_n":null,"requirement":null,"reference":null}},{"id":1453,"created_at":"2024-10-29T16:03:04.000000Z","updated_at":"2024-10-29T16:03:04.000000Z","deleted_at":null,"framework_id":70,"title":"Grado di Disabilit\u00e0 (EDSS)","typology":"MULTIPLECHOICE","measure_unit":null,"evaluation":null,"order":14,"options":[{"id":6204,"created_at":"2024-10-29T16:03:05.000000Z","updated_at":"2024-10-29T16:03:05.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1453,"title":"0.0","weight":0},{"id":6205,"created_at":"2024-10-29T16:03:05.000000Z","updated_at":"2024-10-29T16:03:05.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1453,"title":"1.0-1.5","weight":11},{"id":6206,"created_at":"2024-10-29T16:03:05.000000Z","updated_at":"2024-10-29T16:03:05.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1453,"title":"2.0-2.5","weight":22},{"id":6207,"created_at":"2024-10-29T16:03:05.000000Z","updated_at":"2024-10-29T16:03:05.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1453,"title":"3.0-3.5","weight":33},{"id":6208,"created_at":"2024-10-29T16:03:05.000000Z","updated_at":"2024-10-29T16:03:05.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1453,"title":"4.0-4.5","weight":44},{"id":6209,"created_at":"2024-10-29T16:03:05.000000Z","updated_at":"2024-10-29T16:03:05.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1453,"title":"5.0-5.5","weight":56},{"id":6210,"created_at":"2024-10-29T16:03:05.000000Z","updated_at":"2024-10-29T16:03:05.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1453,"title":"6.0-6.5","weight":67},{"id":6211,"created_at":"2024-10-29T16:03:05.000000Z","updated_at":"2024-10-29T16:03:05.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1453,"title":"7.0-7.5","weight":78},{"id":6212,"created_at":"2024-10-29T16:03:05.000000Z","updated_at":"2024-10-29T16:03:05.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1453,"title":"8.0-8.5","weight":89},{"id":6213,"created_at":"2024-10-29T16:03:06.000000Z","updated_at":"2024-10-29T16:03:06.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1453,"title":"9.0-9.5","weight":95},{"id":6214,"created_at":"2024-10-29T16:03:06.000000Z","updated_at":"2024-10-29T16:03:06.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1453,"title":"Decesso","weight":100}],"additional":{"id":1174,"created_at":"2024-10-29T16:03:06.000000Z","updated_at":"2024-10-29T16:03:06.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1453,"item_id":null,"section":"FATTORI DI RISCHIO E INDICATORI DI PROGNOSI","sub_section":"FATTORI DI RISCHIO E INDICATORI DI PROGNOSI","preliminary_check":null,"check_n":null,"requirement":null,"reference":null}},{"id":1454,"created_at":"2024-10-29T16:03:06.000000Z","updated_at":"2024-10-29T16:03:06.000000Z","deleted_at":null,"framework_id":70,"title":"Attivit\u00e0 Radiologica: Nuove lesioni alla risonanza magnetica (specificare sede nelle note)","typology":"MULTIPLECHOICE","measure_unit":null,"evaluation":null,"order":15,"options":[{"id":6215,"created_at":"2024-10-29T16:03:06.000000Z","updated_at":"2024-10-29T16:03:06.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1454,"title":"SI - Sintomatica","weight":100},{"id":6216,"created_at":"2024-10-29T16:03:06.000000Z","updated_at":"2024-10-29T16:03:06.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1454,"title":"SI - Asintomatica","weight":50},{"id":6217,"created_at":"2024-10-29T16:03:06.000000Z","updated_at":"2024-10-29T16:03:06.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1454,"title":"NO","weight":0}],"additional":{"id":1175,"created_at":"2024-10-29T16:03:06.000000Z","updated_at":"2024-10-29T16:03:06.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1454,"item_id":null,"section":"FATTORI DI RISCHIO E INDICATORI DI PROGNOSI","sub_section":"FATTORI DI RISCHIO E INDICATORI DI PROGNOSI","preliminary_check":null,"check_n":null,"requirement":null,"reference":null}},{"id":1455,"created_at":"2024-10-29T16:03:07.000000Z","updated_at":"2024-10-29T16:03:07.000000Z","deleted_at":null,"framework_id":70,"title":"Gravit\u00e0 dei Sintomi Iniziali","typology":"MULTIPLECHOICE","measure_unit":null,"evaluation":null,"order":16,"options":[{"id":6218,"created_at":"2024-10-29T16:03:07.000000Z","updated_at":"2024-10-29T16:03:07.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1455,"title":"Lieve","weight":0},{"id":6219,"created_at":"2024-10-29T16:03:07.000000Z","updated_at":"2024-10-29T16:03:07.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1455,"title":"Moderata","weight":33},{"id":6220,"created_at":"2024-10-29T16:03:07.000000Z","updated_at":"2024-10-29T16:03:07.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1455,"title":"Grave","weight":66},{"id":6221,"created_at":"2024-10-29T16:03:07.000000Z","updated_at":"2024-10-29T16:03:07.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1455,"title":"Molto Grave","weight":100}],"additional":{"id":1176,"created_at":"2024-10-29T16:03:07.000000Z","updated_at":"2024-10-29T16:03:07.000000Z","deleted_at":null,"framework_id":70,"framework_criteria_id":1455,"item_id":null,"section":"FATTORI DI RISCHIO E INDICATORI DI PROGNOSI","sub_section":"FATTORI DI RISCHIO E INDICATORI DI PROGNOSI","preliminary_check":null,"check_n":null,"requirement":null,"reference":null}}],"constraints":[],"roles":[]}
  }

  get criteriaTargetsWeightsEnabled() {
    if (this.model?.criteria?.length > 0 &&
      this.model?.criteria[0].typology &&
      this.model?.primary_target?.evaluation_criteria &&
      this.model?.analysis_type !== null &&
      !this.getAnalysisService().isConsensusByType(this.model?.analysis_type)) {

      if (this.model?.secondary_targets?.length === 0 && this.getAnalysisService().isMulticriteriaByType(this.model?.analysis_type)) {
        return true;
      }

      if (this.model?.secondary_targets?.length > 1 && this.getAnalysisService().isMultiobjectiveByType(this.model?.analysis_type)) {
        return true;
      }
    }

    return false;
  }


  /**
   * Gestione della selezione dei metodi di analisi
   */
  disableAnalysis() {
    this.analysisMethods.forEach(element => {
      element.enabled = false;
    });
  }

  public getAnalysisService() {
    return this.analysisService;
  }

  get stringifyModel() {
    return JSON.stringify(this.model);
  }

  analysisOnClick(methodIndex: number) {
    this.disableAnalysis();
    this.analysisMethods[methodIndex].enabled = !this.analysisMethods[methodIndex].enabled;
    this.model.analysis_type = this.analysisMethods[methodIndex].type;
  }

  /** Evento di cambio dell'organizzazione della select */
  selectOrganizationOnChange() {
    this.currentOrganization = this.userorganization.find(x => x.id == this.model.organization_id);
  }

  /**
   * Gestione dei box dei settori
   */
  getSubsectorsArrayFiltered(sectorKey) {
    return this.workingSectorService.getAllsubsectorsForSelectBySectorKey(sectorKey);
  }

  addSector() {
    this.model.sectors.push({sector_key: null, subsector_key: null});
  }

  removeSector(positionToDelete) {
    this.model.sectors.splice(positionToDelete, 1);
    if (this.model.sectors.length == 0) {
      this.addSector();
    }
  }


  /**
   * Gestione dei box degli obiettivi
   */
  addSecondaryTarget() {
    this.model.secondary_targets.push({type: 'secondary', title: '', evaluation_criteria: null});
  }

  removeSecondaryTarget(positionToDelete) {
    this.model.secondary_targets.splice(positionToDelete, 1);
  }


  /**
   * Gestione dei box dei criteri
   */
  onChangeCriteriaTypology(criteriaIndex) {

    //  se sto creando un criterio multiscelta e ancora non ho nessuna opzione inserita allora lo faccio
    if (this.criteriaService.criteriaIsMultipleChoice(this.model.criteria[criteriaIndex].typology)
      && !this.model.criteria[criteriaIndex].options) {
      this.addCriteriaOption(criteriaIndex);
    }
  }

  addCriteria() {
    this.model.criteria.push({
      order: this.model.criteria.length + 1,
      title: '',
      measure_unit: null,
      evaluation: null,
      typology: null,
      additional: {}
    });
  }

  weightsUpdated(value) {
    this.settedWeights = {...value};
    this.cdr.detectChanges();
  }

  removeCriteria(positionToDelete) {
    this.model.criteria.splice(positionToDelete, 1);
    if (this.model.criteria.length == 0) {
      this.addCriteria();
    }
  }

  duplicateCriteria(criterio) {
    this.model.criteria.push(JSON.parse(JSON.stringify(criterio)));
  }

  addCriteriaOption(criteriaIndex) {
    if (!this.model.criteria[criteriaIndex].options) {
      this.model.criteria[criteriaIndex].options = [];
    }

    this.model.criteria[criteriaIndex].options.push({title: ''});
  }

  removeCriteriaOption(criteriaIndex, positionToDelete) {
    this.model.criteria[criteriaIndex].options.splice(positionToDelete, 1);
    if (this.model.criteria[criteriaIndex].options.length == 0) {
      this.addCriteriaOption(criteriaIndex);
    }
  }

  /**
   * Gestione dei box dei criteri
   */
  addConstraint() {
    this.model.constraints.push({description: '', from: null, to: null});
  }

  removeConstraint(positionToDelete) {
    this.model.constraints.splice(positionToDelete, 1);
  }


  /**
   * Gestione della selezione dei bottoni di opzione dei ruoli
   */
  optionRoleOnClick(event) {
    this.model.options_role = event;

    if (this.model.options_role == true) {
      this.addRole();
    } else {
      this.model.roles = [];
    }
  }


  /**
   * Gestione dell'obbligatorietà dei bottoni dei ruoli
   */
  optionRoleRequiredOnClick(event) {
    this.model.options_role_required = event;
  }


  /**
   * Gestione dei box dei ruoli
   */
  addRole() {
    this.model.roles.push({
      organization_professional_role_id: null, process_role: null,
      complete_process_enabled: true, review_enabled: true, provide_new_proposal_enabled: true
    });
  }

  removeRole(positionToDelete) {
    this.model.roles.splice(positionToDelete, 1);
    if (this.model.roles.length == 0) {
      this.addRole();
    }
  }


  /**
   * Aggiunta di un nuovo allegato
   * @param criterio
   * @param attachment_type
   */
  onClickUploadFile() {

    const dialogRef = this.dialog.open(ModalUploadFrameworkComponent, {
      panelClass: 'medium-dialog',
      data: {
        title: 'modals.modal-upload-framework',
        uploadUrl: 'upload/generate-framework',
        type: ['xls', 'xlsx', 'csv']
      }
    });

    //  se ho creato correttamente il framework allora lo mostra
    dialogRef.afterClosed().subscribe(uploadedData => {
      if (uploadedData && uploadedData.attachmentObject && uploadedData.attachmentObject.length > 0 && uploadedData.attachmentObject[0].id) {

        //  porto l'utente alla home
        // this.router.navigate(['framework', uploadedData.attachmentObject[0].id]);
        this.toast.success(this.translateService.instant('generic.decision-schema'), this.translateService.instant('pages.frameworks.framework.success-decision-scheme'));
        this.router.navigate(['/home']);
      }
    });
  }


  /**
   * Evento di submit di tutta la pagina
   */
  onSubmit() {

    //  validazione dei dati

    this.model.organization_id = this.currentOrganization.id;

    if (!this.model.title) {
      this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-decision-schema'));
      return;
    }
    if (!this.model.organization_id) {
      this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-organization'));
      return;
    }
    if (!this.model.analysis_type) {
      this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-methodology'));
      return;
    }
    if (!this.sectorsValid) {
      this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-sector'));
      return;
    }
    if (!this.model.purpose_description) {
      this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-description'));
      return;
    }
    if (!this.primaryTargetsValid) {
      this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-primary-obj'));
      return;
    }
    if (!this.secondaryTargetsValid) {
      return;
    }
    if (!this.criteriaValid) {
      return;
    }
    if (!this.constraintsValid) {
      this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-constraints'));
      return;
    }
    if (!this.question_role_satisfied) {
      this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-question-team'));
      return;
    }
    if (this.model.options_role == true && !this.role_satisfied) {
      this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-role-team'));
      return;
    }

    const model = {
      ...this.model,
      settedWeights: this.weights_is_setted ? this.settedWeights : undefined,
      weights_mandatories: !!this.weights_mandatories
    };

    if (this.weights_is_setted && this.getCriteriaWeightsSum(model.settedWeights) !== 100) {
      this.toast.error(this.translateService.instant('generic.error'), this.translateService.instant('modals.modal-edit-weights.weights-total-must-be-100'));
      return;
    }

    this.loading = true;
    this.frameworkService.save(model, (result) => {
      this.loading = false;
      this.toast.success(this.translateService.instant('generic.decision-schema'), this.translateService.instant('pages.frameworks.framework.success-decision-scheme'));
      this.router.navigate(['./all'], {relativeTo: this.activeRoute});
    }, (error) => {
      this.loading = false;
    });

  }

  getCriteriaWeightsSum(model) {
    return model.primary_target.criteria
      .map((criteria: any) => criteria.evaluation?.weight || 0)
      .reduce((acc: number, weight: number) => acc + weight, 0);
  }


  /**
   * Evento di submit che invia solo l'aggiornamento dei dati del framework
   * i dati che è possibile aggiornare sono pochi e selezionai
   */
  onSubmitUpdate() {


    const modelUpdate = {
      hidden: this.model.hidden,
      public: this.model.public
    };

    this.loading = true;
    this.frameworkService.update(this.model.id, modelUpdate, (result) => {
      this.loading = false;
      this.toast.success(this.translateService.instant('generic.decision-schema'), this.translateService.instant('pages.frameworks.framework.updated-decision-scheme'));
    }, (error) => {
      this.loading = false;
    });

  }


  /**
   *  Scarica o il framework o un esempio di CSV, XLS del framework
   */
  onClickDownloadExampleData() {
    this.frameworkService.donwloadData(this.id);
  }


  /**
   * Valida i settori
   */
  get sectorsValid() {
    if (this.model.sectors.length == 0) {
      return false;
    }
    for (const sector of this.model.sectors) {
      if (!sector.sector_key) {
        return false;
      }
    }
    return true;
  }


  /**
   * Valida gli obiettivi inseriti
   */
  get primaryTargetsValid() {
    if (!this.model.primary_target.evaluation_criteria || !this.model.primary_target.title) {
      return false;
    }
    return true;
  }

  /**
   * Valida gli obiettivi secondari inseriti
   */
  get secondaryTargetsValid() {
    let counter = 0;
    for (const secondary_target of this.model.secondary_targets) {
      if (!secondary_target.title || !secondary_target.evaluation_criteria) {
        this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-secondary-obj'));
        return false;
      }
      counter++;
    }

    //  Se è una multiobiettivo bisogna avere almeno due obiettivi secondari inseriti
    if (this.model.analysis_type == 5 && counter < 2) {
      this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-multitarget-secondary-obj'));
      return false;
    }

    //  Se è una multicriterio non devono esserci obiettivi secondari
    if (this.model.analysis_type == 1 && counter > 0) {
      this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-multicriteria-secondary-obj'));
      return false;
    }

    //  Nella consensus non devono esserci obiettivi secondari
    if (this.model.analysis_type == 2 && counter > 0) {
      this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-consent-analysis'));
      return false;
    }

    //  Nel Voting non devono esserci obiettivi secondari
    if (this.model.analysis_type == 3 && counter > 0) {
      this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-voting-secondary-obj'));
      return false;
    }

    return true;
  }

  get allTargets() {
    return [...this.model?.secondary_targets];
  }

  /**
   * Valida i criteri inseriti
   */
  get criteriaValid() {
    let counter = 0;
    for (const criteria of this.model.criteria) {
      if (!criteria.typology || !criteria.title) {
        this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-criteria-not-valid'));
        return false;
      } else if (this.criteriaService.criteriaIsQuantitative(criteria.typology) && !criteria.measure_unit && !criteria.evaluation) {
        this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-criteria-not-valid'));
        return false;
      }

      counter++;
    }

    //  se è stato selezionato anche solo un criterio a scelta multipla allora tutti devono essere a scelta multipla
    if (!this.multichoiceCriteriaValid && this.userService?.currentOrganization?.customs?.profile == 'enel') {
      this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-criteria-not-multiplechoice'));
      return false;
    }

    //  eccezione per enel, perché gli altri utenti non dovranno vedere i campi aggiuntivi
    if (['enel', 'alexion'].includes(this.currentOrganization.customs?.profile)) {
      for (const criteria of this.model.criteria) {
        if (this.currentOrganization.customs?.profile === 'enel') {
          if (!criteria.additional.item_id || !criteria.additional.section || !criteria.additional.sub_section) {
            return false;
          }
        }
        if (this.currentOrganization.customs?.profile === 'alexion') {
          if (!criteria.additional.section || !criteria.additional.sub_section) {
            return false;
          }
        }
      }
    }

    //   nella parte della consensus i criteri quantitativi non devono esserci
    if (this.model.analysis_type == 2) {
      for (const criteria of this.model.criteria) {
        if (this.criteriaService.criteriaIsQuantitative(criteria.typology)) {
          this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-quantitative-criteria'));
          return false;
        }
        if (this.criteriaService.criteriaIsMultipleChoice(criteria.typology)) {
          this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-multiplechoice-criteria'));
          return false;
        }
      }
    }

    //  Se è una multicriterio i criteri devono essere almeno 2
    if (this.model.analysis_type == 1 && counter < 2) {
      this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-multicriteria-criteria-number'));
      return false;
    }

    //  Nel Voting deve esserci un solo criterio
    if (this.model.analysis_type == 3 && counter > 1) {
      this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-voting-criteria'));
      return false;
    }

    return true;
  }

  /**
   * Valida i criteri in caso di scelta multipla
   */
  get multichoiceCriteriaValid() {
    //  controllo che ci sia almeno un criterio a scelta multipla
    const thereIsMultipleChoiceCriteria = this.model.criteria.filter(x => this.criteriaService.criteriaIsMultipleChoice(x.typology));
    if (thereIsMultipleChoiceCriteria && thereIsMultipleChoiceCriteria.length > 0) {

      //  se c'è almeno un criterio a scelta multipla allora controllo che tutti siano a scelta multipla
      const thereIsNotMultipleChoiceCriteria = this.model.criteria.filter(x => !this.criteriaService.criteriaIsMultipleChoice(x.typology));
      if (thereIsNotMultipleChoiceCriteria && thereIsNotMultipleChoiceCriteria.length > 0) {
        return false;
      }

      //  se sono tutti a scelta multipla, controllo che siano stati dati almeno 2 opzioni per ogni criterio a scelta multipla
      for (const criteria of this.model.criteria) {
        if (criteria.options) {
          criteria.options = criteria.options.filter(x => x.title != '');
        }
        if (!criteria.options || criteria.options.length < 2) {
          this.toast.error(this.translateService.instant('generic.warning'), this.translateService.instant('pages.frameworks.framework.error-criteria-multiplechoice-not-enough-options'));
          return false;
        }
      }
    }
    return true;
  }

  /**
   * Valida i vincoli
   */
  get constraintsValid() {
    for (const constraint of this.model.constraints) {
      if (isNaN(parseInt(constraint.criteria_1_order)) || isNaN(parseInt(constraint.criteria_2_order)) || !constraint.description) {
        return false;
      } else if (constraint.criteria_1_order == constraint.criteria_2_order) {
        return false;
      }

      //  controllo anche se sono stati vincolati alcuni criteri simili tra loro
      let checkConstrait = this.model.constraints.filter(x => x.criteria_1_order == constraint.criteria_1_order);
      checkConstrait = checkConstrait.filter(y => y.criteria_2_order == constraint.criteria_2_order);
      if (checkConstrait.length > 1) {
        return false;
      }
      checkConstrait = this.model.constraints.filter(x => x.criteria_1_order == constraint.criteria_2_order);
      checkConstrait = checkConstrait.filter(y => y.criteria_2_order == constraint.criteria_1_order);
      if (checkConstrait.length > 0) {
        return false;
      }
    }
    return true;
  }

  /**
   * Valida le risposte prima di aprire il team
   */
  get question_role_satisfied(): boolean {

    //  se non si vogliono inserire i ruoli
    if (this.model.options_role == false) {
      return true;
    }

    //  se si vogliono inserire i ruoli e si è risposto alla richiesta di obbligatorietà di uso dei ruoli
    if (this.model.options_role == true && this.model.options_role_required != null) {
      return true;
    }

    return false;
  }


  /**
   * Valida i ruoli sul framework
   */
  get role_satisfied(): boolean {

    for (const roles of this.model.roles) {
      if (!roles.organization_professional_role_id || !roles.process_role) {
        return false;
      }
    }
    return true;
  }


  public getUnitsService() {
    return this.unitsService;
  }

  public getCriteriaService() {
    return this.criteriaService;
  }

  public getWorkingSectorService() {
    return this.workingSectorService;
  }

  public getProcessRolesService() {
    return this.processRolesService;
  }

  get dynamicAnalysisMethods() {
    if (this.id) {
      return this.analysisMethods.filter((method) => method.enabled === true);
    } else {
      return this.analysisMethods;
    }
  }

  public choiceSetWeights(value) {
    this.weights_is_setted = value;
    if (!value) {
      this.weights_mandatories = null;
    }
  }

  public choiceSetMandatoriesWeights(value) {
    this.weights_mandatories = value;
  }
}
